export const HOME = { emergentLink: "emergent-link" };

export const T = {
  // nav
  navLogo: "nav-logo",
  navBuy: "nav-buy-btn",
  // hero
  heroBuy: "hero-buy-btn",
  heroExplore: "hero-explore-btn",
  // ebook
  ebookMockup: "ebook-mockup-clickable",
  ebookBuyBtn: "ebook-buy-btn",
  // scandal cards
  cardMensalao: "card-mensalao",
  cardLavaJato: "card-lavajato",
  cardTriplex: "card-triplex",
  cardAnosPT: "card-anospt",
  // CTAs
  finalBuy: "final-buy-btn",
  floatBuy: "floating-buy-btn",
  purchaseBuy: "purchase-buy-btn",
  // lead
  leadName: "lead-name",
  leadEmail: "lead-email",
  leadSubmit: "lead-submit",
  // admin
  adminEmail: "admin-email",
  adminPassword: "admin-password",
  adminLogin: "admin-login-btn",
  adminLogout: "admin-logout-btn",
  // faq
  faq: "faq-accordion",
};
